import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
export default {
	/**
	 * 报警信息列表接口
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	alarmList( params={} ) {
		params = commonJs.obj.removeNullKey(params)
		return request({
	    url: baseUrl + '/device/alarms',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 报警信息更新接口
	**/
	alarmUpdate(id){
		return request({
			url: baseUrl + '/device/alarms/'+id,
			method:'PUT'
		})
	},

	/**
	 * 策略删除
	**/
	alarmDel(id){
		return request({
			url: baseUrl + '/device/alarms/'+id,
			method:'DELETE'
		})
	}
}